
import document from 'document';
import { eventBus } from '../../foundation/eventBus';

export const zenNavEvents = {
    openMenu: 'openMenu'
}
export const zenNavSelectors = {
    menuHeader: '.zen-nav-menu-header-mobile',
    navMenu: '.zen-nav-menu',
    navMenuOpen: 'zen-nav-menu--open',
    navVeil: '.zen-nav-veil__link',
    navOpen: 'navigation-is-active',
    menu: '.menu-bar',
    bannerLink: 'nav-login-link',
    subNavOpen: 'nav-submenu__list--open',
    subNavMenu: '.nav-submenu__list'
};
export const zenNavElements = () => {
    return {
        menu: document.querySelector(zenNavSelectors.menu),
        navMenu: document.querySelector(zenNavSelectors.navMenu),
        menuHeader: document.querySelector(zenNavSelectors.menuHeader),
        navVeil: document.querySelector(zenNavSelectors.navVeil),
        bannerLink: document.querySelector('.menu-bar .zen-login-cta--mobile .nav-login-link'),
        subNavMenu: document.querySelector(zenNavSelectors.subNavMenu),
        burgerMenuButton: document.querySelector('.zen-nav-header-mobile .zen-burger-menu')
    }
}
export const zenNavHeader = () => {
    const init = component => {
        const handleClick = () => {
            const elements = zenNavElements();
            const { navOpen: openSelector, navMenuOpen} = zenNavSelectors;
            elements.navMenu.classList.add(navMenuOpen);
            elements.menuHeader.classList.add(openSelector);
            elements.menu.classList.add(openSelector);
            elements.navVeil.classList.add(openSelector);
            eventBus.publish(zenNavEvents.openMenu);
            elements.burgerMenuButton.setAttribute('aria-expanded', true);
            elements.bannerLink.focus();
        };
        component.addEventListener('click', handleClick);
    };
    return {
        init: init,
        selector: '.zen-burger-menu'
    };
};